// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"079765e5","539":"157c3c6f","787":"71df535f","932":"2cf2bc7b"}[chunkId] + ".chunk.js";
};